export const CURRENT_MODAL = "CURRENT_MODAL";
export const ACTIVITY_DETAILS = "ACTIVITY_DETAILS";
export const QUERY_DETAILS = "QUERY_DETAILS";
export const MEMBER_DETAILS = "MEMBER_DETAILS";
export const USER_DETAILS = "USER_DETAILS";
export const LOADING = "LOADING";
export const LOAD_LOCATIONS = "LOAD_LOCATIONS";
export const SHOW_SEARCH_RESULT = "SHOW_SEARCH_RESULT";
export const SET_OTP = "SET_OTP";
export const LIST_CATEGORIES = "LIST_CATEGORIES";
export const USER_DATA = "USER_DATA";
export const USER_ID = "USER_ID";
export const USER_PHONE = "USER_PHONE";
export const BUTTON_LOADER = "BUTTON_LOADER";
export const RESET_OTP = "RESET_OTP";
export const SET_PASSWORD = "SET_PASSWORD";
export const API_PATH = "/api/web/vdev/";

// export const API_PATH = "https://fuji.trodly.com/api/web/vdev/";

export const ROOT = "/";
export const MY_ENQUIRIES = "/my-profile/enquiries";
